/* Auto-generated route names registry - do not edit manually */
export const routeNames = {
  adminHome: 'adminHome',
  auth: 'auth',
  authLogin: 'authLogin',
  authRoleSelection: 'authRoleSelection',
  authSignupSenior: 'authSignupSenior',
  authSignupVolunteer: 'authSignupVolunteer',
  error: 'error',
  requestChatDetail: 'requestChatDetail',
  requestChatsList: 'requestChatsList',
  senior: 'senior',
  seniorComposeRequest: 'seniorComposeRequest',
  seniorComposeRequestChat: 'seniorComposeRequestChat',
  seniorComposeRequestManual: 'seniorComposeRequestManual',
  seniorComposeRequestReview: 'seniorComposeRequestReview',
  seniorComposeRequestSuccess: 'seniorComposeRequestSuccess',
  seniorMyRequestDetail: 'seniorMyRequestDetail',
  seniorMyRequestEdit: 'seniorMyRequestEdit',
  seniorMyRequests: 'seniorMyRequests',
  seniorMyRequestsList: 'seniorMyRequestsList',
  seniorProfile: 'seniorProfile',
  seniorProfileEmergencyContact: 'seniorProfileEmergencyContact',
  seniorProfileInfo: 'seniorProfileInfo',
  seniorProfilePhone: 'seniorProfilePhone',
  volunteer: 'volunteer',
  volunteerAvailableRequests: 'volunteerAvailableRequests',
  volunteerMyRequests: 'volunteerMyRequests',
  volunteerProfile: 'volunteerProfile',
  volunteerProfileInfo: 'volunteerProfileInfo',
  volunteerProfilePhone: 'volunteerProfilePhone',
  volunteerRequestDetail: 'volunteerRequestDetail',
  volunteerRequests: 'volunteerRequests'
}
